import type { BrandTheme } from '../../contexts/BrandContext';

// Public booking pages serve our customers' customers: never tracked.
const EXCLUDED_PATH_PREFIXES = ['/book/', '/manage/'];

export const isExcludedPath = (pathname: string): boolean =>
  EXCLUDED_PATH_PREFIXES.some(prefix => pathname.startsWith(prefix));

/**
 * Whether the app may capture the ad origin and ask for marketing consent here:
 * not on white-label domains, not on public booking pages, and not before the
 * brand is known.
 */
export const isTrackingScope = (
  brand: Pick<BrandTheme, 'is_whitelabel'>,
  isBrandLoading: boolean,
  pathname: string
): boolean => !isBrandLoading && !brand.is_whitelabel && !isExcludedPath(pathname);
